<div class="chips" [class.chips--selected]="hasSelectedState">
  <div class="chips__button-container">
    <button
      app-vtmn-play-button
      type="button"
      [type]="ctaButtonType.Button"
      [size]="vtmnPlayButtonSize.SMALL"
      [variant]="
        hasSelectedState
          ? vtmnPlayButtonVariant.PRIMARY
          : vtmnPlayButtonVariant.SECONDARY
      "
      (click)="toggleDialog()"
    >
      {{ buttonText }}
    </button>
  </div>

  <div
    *ngIf="isDialogOpen"
    #dialog
    class="chips__dialog"
    role="dialog"
    aria-modal="true"
    data-test="filter-result"
  >
    <span class="focusable" tabindex="0" (focus)="focusLastFocusable()"></span>

    <div class="chips__dialog__header">
      <button
        app-vtmn-play-icon-button
        type="button"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayIconButtonVariant.TERTIARY"
        class="chips__dialog__header__button"
        (click)="toggleDialog()"
      >
        <vtmn-play-icon [name]="icon?.Close"></vtmn-play-icon>
      </button>

      <p class="chips__dialog__header__title">
        {{ dialogTitle }}
      </p>
    </div>

    <ng-content></ng-content>

    <span class="focusable" tabindex="0" (focus)="focusDialogTitle()"></span>
  </div>
</div>
